import AMP from './amp';
import MemoryStorage from '@arc-publishing/sdk-subs-core/lib/utils/memoryStorage';
import CookieStorage from '@arc-publishing/sdk-subs-core/lib/utils/cookieStorage';

/** @hidden */
export async function getOptions(options: any = {}) {
  const isLoggedIn = await AMP._Identity.isLoggedIn();
  let reqOptions = {
    ...options,
    headers: isLoggedIn
      ? { ...options.headers, Authorization: AMP._Identity.userIdentity.accessToken }
      : { ...options.headers }
  };
  if (!isLoggedIn) {
    reqOptions = { ...reqOptions, credentials: 'include' };
  }
  return reqOptions;
}

export function getValidURL(url?: string) {
  if (typeof window === 'undefined') {
    return url;
  }

  if (!url) {
    return '';
  }

  let newUrl = window.decodeURIComponent(url);
  newUrl = newUrl.trim().replace(/\s/g, '');

  if (/^(:\/\/)/.test(newUrl)) {
    return `https${newUrl}`;
  }
  if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
    return `https://${newUrl}`;
  }

  return newUrl;
}

export const initStorage = (baseDomain?: string) => {
  if (typeof window === 'undefined') {
    return new MemoryStorage();
  }

  if (baseDomain) {
    return new CookieStorage(baseDomain);
  }

  try {
    const testKey = 'ArcId.test';
    localStorage.setItem(testKey, 'testValue');
    localStorage.removeItem(testKey);
    return localStorage;
  } catch (_) {
    // for old safari in private mode or no space in webstorage.
    return new CookieStorage(baseDomain);
  }
};
